import { type FC, type PropsWithChildren } from 'react'

type LoginRegistrationOneTimePasswordInputProps = {
  hasError: boolean
  length?: number
}

import { clsx } from 'clsx'
import { useIntl } from 'react-intl'

import { OTP_LENGTH } from '../LoginRegistrationOneTimePasswordInputForm/loginRegistrationOneTimePasswordInputFormData'

import { useLoginRegistrationOneTimePasswordInput } from './useLoginRegistrationOneTimePasswordInput'

import styles from './LoginRegistrationOneTimePasswordInput.module.css'

export const LoginRegistrationOneTimePasswordInput: FC<
  PropsWithChildren<LoginRegistrationOneTimePasswordInputProps>
> = ({ children, hasError, length = OTP_LENGTH }) => {
  const intl = useIntl()
  const {
    handleBlur,
    handleChange,
    handleFocus,
    handleInputRef,
    handleKeyDown,
    handlePaste,
    inputKeys,
    otp,
    showError,
  } = useLoginRegistrationOneTimePasswordInput(length)

  return (
    <div>
      <div className="flex justify-between">
        {otp.map((data, index) => (
          <div className={styles['otp-input-wrapper']} key={inputKeys[index]}>
            <input
              aria-label={intl.formatMessage(
                { id: 'login.otp.code.digits' },
                {
                  digitNumber: index + 1,
                },
              )}
              className={clsx(
                styles['otp-input-wrapper'],
                styles['otp-input'],
                showError && hasError && styles.error,
              )}
              data-qa-id={`otp-input-${index}`}
              inputMode="numeric"
              maxLength={1}
              onBlur={handleBlur}
              onChange={(event) => {
                handleChange(event, index)
              }}
              onFocus={handleFocus}
              onKeyDown={(event) => {
                handleKeyDown(event, index)
              }}
              onPaste={handlePaste}
              ref={(element) => {
                handleInputRef(element, index)
              }}
              type="text"
              value={otp[index] || ''}
            />
          </div>
        ))}
      </div>
      {showError ? children : null}
    </div>
  )
}
